import { baseService } from '@repo/services';
import { type CamelToSnakeCaseKeys, transformGraphqlResponse } from '@repo/utils';
import { getLeadDistributionQuery, type GetLeadDistributionQueryType } from 'crm-atoms/queries/getLeadDistribution';

export interface DistributionRuleType {
  name: string;
  criteriaGroupId: number;
  entities: {
    entityUuid: string;
  }[];
}

export interface CreateLeadDistributionPayload {
  defaultUserUuid?: string | null;
  rules: DistributionRuleType[];
}

export interface CreateLeadDistributionResponse {
  success: boolean;
  lead_distribution: {
    id: number;
  };
}

const leadDistributionService = baseService.injectEndpoints({
  endpoints: (build) => ({
    createLeadDistribution: build.mutation<
    CreateLeadDistributionResponse,
    CamelToSnakeCaseKeys<CreateLeadDistributionPayload>
    >({
      query: (body) => ({
        method: 'POST',
        url: '/v1/lead_distributions',
        body: {
          lead_distribution: body,
        },
      }),
    }),
    getLeadDistribution: build.query<GetLeadDistributionQueryType, number>({
      query: (id) => ({
        method: 'POST',
        url: '/graphql',
        body: {
          query: getLeadDistributionQuery,
          variables: {
            id,
          },
        },
      }),
      transformResponse: transformGraphqlResponse,
    }),
    updateLeadDistribution: build.mutation<
    CreateLeadDistributionResponse,
    { id: number, body: CamelToSnakeCaseKeys<CreateLeadDistributionPayload> }
    >({
      query: ({ id, body }) => ({
        method: 'PUT',
        url: `/v1/lead_distributions/${id}`,
        body: {
          lead_distribution: body,
        },
      }),
    }),
  }),
});

export const {
  useCreateLeadDistributionMutation,
  useGetLeadDistributionQuery,
  useUpdateLeadDistributionMutation,
} = leadDistributionService;
